import React, { createContext, useEffect, useState } from "react";
import BChart from "../Chart/BChart";
import LiChart from "../Chart/LiChart";
import PChart from "../Chart/PChart";
import VComposedChart from "../Chart/VComposedChart";

export const ChartContext = createContext("chartData");

const Dashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("data.json")
      .then((res) => res.json())
      .then((data) => setData(data));
  }, [data]);

  return (
    <ChartContext.Provider value={data}>
      <div className="container mt-5">
        <div className="row justify-content-center text-center ">
          <div className="mb-5 col">
            <LiChart></LiChart>
          </div>
          <div className=" col">
            <BChart></BChart>
          </div>
        </div>
        <div className="row justify-content-center text-center mt-5">
          <div className="col">
            <PChart></PChart>
          </div>
          <div className="col">
            <VComposedChart></VComposedChart>
          </div>
        </div>
      </div>
    </ChartContext.Provider>
  );
};

export default Dashboard;
